// RowActionsMenu.jsx
import React, { useState } from "react";
import { IconButton, Menu, MenuItem } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import PropTypes from "prop-types";

const RowBranchActionsMenu = ({
  row,
  onDelete,
  onEdit,
  onCreateBranchIntake,
  onViewBranchIntakes,
  hasPermissionDirect,
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleOpen = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);
  const isInactive = row.is_branch_active == 0;
  return (
    <>
      <IconButton onClick={handleOpen}>
        <MoreVertIcon />
      </IconButton>
      <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
        <MenuItem
          onClick={() => {
            onEdit(row);
            handleClose();
          }}
        >
          Edit Branch
        </MenuItem>

        <MenuItem
          onClick={() => {
            onDelete(row.branch_id);
            handleClose();
          }}
        >
          Delete Branch
        </MenuItem>
      </Menu>
    </>
  );
};
RowBranchActionsMenu.propTypes = {
  row: PropTypes.shape({
    college_id: PropTypes.number.isRequired,
    program_id: PropTypes.number.isRequired,
    branch_id: PropTypes.number.isRequired,
    branch_desc: PropTypes.string.isRequired,
    branch_name: PropTypes.string.isRequired,
    program_name: PropTypes.string.isRequired,
    is_branch_active: PropTypes.number.isRequired,
  }).isRequired,
  onEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  onCreateBranchIntake: PropTypes.func,
  onViewBranchIntakes: PropTypes.func,
  hasPermissionDirect: PropTypes.func.isRequired,
};
RowBranchActionsMenu.defaultProps = {
  onCreateBranchIntake: null,
  onViewBranchIntakes: null,
};
export default RowBranchActionsMenu;
